"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgPrint(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M13 29H5c-1.105 0-2-.796-2-1.778V14.778C3 13.796 3.895 13 5 13h30c1.105 0 2 .796 2 1.778v12.444c0 .982-.895 1.778-2 1.778h-8", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("rect", { x: 13, y: 25, width: 14, height: 10, rx: 2, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M13 12.276V7a2 2 0 012-2h10a2 2 0 012 2v5.016", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M28.5 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM32.5 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgPrint;
//# sourceMappingURL=Print.js.map